var _defs, _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.8rem",
    height: "0.5rem",
    viewBox: "0 0 55.930304 39.918163",
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-17.749133,-20.974547)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.2229113,-10.00729)",
    id: "_x30_02-success"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 77.5,31.7 46.8,66.3 28.2,51.4 c -0.9,-0.7 -2.1,-0.5 -2.8,0.3 -0.7,0.9 -0.5,2.1 0.3,2.8 l 20,16 c 0.4,0.3 0.8,0.4 1.2,0.4 0.6,0 1.1,-0.2 1.5,-0.7 l 32,-36 c 0.7,-0.8 0.7,-2.1 -0.2,-2.8 -0.7,-0.6 -2,-0.6 -2.7,0.3 z",
    id: "Path",
    fill: "#8EC63F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIcon);
export default __webpack_public_path__ + "static/media/GreenTickIcon.5013f9fcb8877c07f5031d37d94b677b.svg";
export { ForwardRef as ReactComponent };